module.exports = __webpack_public_path__ + "static/img/home12.0aaf941a.png";